// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavigationDropdown-module--wrapper--97479f"};